import { getController } from '@/services/service'

const url = 'report_types'

export const reportTypeService = {
	...getController<Api.ReportType, Api.ReportTypePostInput>(url),
}

export default reportTypeService
